<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Documentos Registrados - {{ nombre }}
  </h2>
  <div class="flex justify-between items-center mb-4">
    <button
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
    <button
      (click)="downloadExcel()"
      class="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
    >
      Descargar Excel
    </button>
  </div>
  <div class="flex justify-between items-center mb-4">
    <div>
      <label class="block font-medium mb-1 text-gray-500">Estado</label>
      <select
        [(ngModel)]="selectedStatus"
        (change)="fetchDocuments()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todos</option>
        <option value="INICIADO">Iniciado</option>
        <option value="LOGRADO">Logrado</option>
        <option value="PROCESO">Proceso</option>
        <option value="OBSERVADO">Observado</option>
        <option value="RECTIFICADO">Rectificado</option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Ordenar por</label>
      <select
        [(ngModel)]="selectedDateOrder"
        (change)="fetchDocuments()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Fecha de subida</option>
        <option value="ASC">Antiguos primero</option>
        <option value="DESC">Recientes primero</option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Buscar</label>
      <div class="relative">
        <input
          type="text"
          class="border border-gray-300 rounded py-2 px-4 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Nombre de institución..."
          [(ngModel)]="searchText"
          (input)="applyFilter()"
        />
        <i class="fas fa-search absolute top-3 left-3 text-gray-500"></i>
      </div>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="min-w-full border-collapse border border-gray-200">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="py-2 px-4 border-b border-gray-200">ID</th>
          <th class="py-2 px-4 border-b border-gray-200">Institución</th>
          <th class="py-2 px-4 border-b border-gray-200">Fecha Subida</th>

          <th class="py-2 px-4 border-b border-gray-200">Link</th>
          <th class="py-2 px-4 border-b border-gray-200">Estado</th>
          <th class="py-2 px-4 border-b border-gray-200">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let doc of getPaginatedDocuments()"
          class="hover:bg-gray-50 transition"
        >
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.id_documento_cargado }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.institucionEducativa?.cen_edu || "N/A" }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.fecha_subida | date : "dd/MM/yyyy" }}
          </td>

          <td class="py-2 px-4 border-b border-gray-200">
            <a
              href="{{ doc.link_archivo }}"
              target="_blank"
              class="text-blue-500 hover:text-blue-600 underline cursor-pointer"
            >
              Ver Archivo
            </a>
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            <span
              [ngClass]="{
                'bg-green-500': doc.estado == 'LOGRADO',
                'bg-blue-500': doc.estado == 'RECTIFICADO',
                'bg-yellow-500': doc.estado == 'INICIADO',
                'bg-orange-500': doc.estado == 'OBSERVADO',
                'bg-gray-500': doc.estado == 'PROCESO'
              }"
              class="text-white px-3 py-1 rounded-full"
              >{{ doc.estado }}</span
            >
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            <button
              class="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-1 px-3 rounded"
              (click)="goToReviewDocument(doc)"
            >
              Revisar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-between items-center mt-6">
    <button
      class="hover:bg-gray-300 border border-gray-300 rounded py-2 px-4"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
    >
      Anterior
    </button>
    <span class="text-gray-700"
      >Página {{ currentPage }} de {{ totalPages }}</span
    >
    <button
      class="hover:bg-gray-300 border border-gray-300 rounded py-2 px-4"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
    >
      Siguiente
    </button>
  </div>
</div>
